<template>
	<div class="main">
		<el-row style="position: relative;">
			<el-col :span="1" style="text-align: center;position: relative;" class="shensuo">
				<!-- <el-tooltip content="侧边伸缩" class="item" effect="light" placement="right-start">
					<i class="el-icon-s-fold iconFont" @click="toHide" v-if="isHide"></i>
					<i class="el-icon-s-unfold iconFont" @click="toShow" v-if="isShow"></i>
				</el-tooltip> -->
			</el-col>
			<el-col :span="1" class="refreshFont" style="position: relative;">
				<!-- 插槽 -->
				<slot></slot>
			</el-col>
			
			<el-col :span="2" class="out">
				<i class="el-icon-switch-button"></i>
				<span class="signOut" @click="logout">退出</span>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: '1',
				isHide: true,
				isShow: false,

			};
		},
		methods: {
			logout() {//退出登录
				this.$confirm('确定退出登录?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					sessionStorage.removeItem("loginUser")
					this.$router.push('/login')
				})
			},

			//收起
			toHide() {
				this.isHide = false;
				this.isShow = true;
				var isWidth = "0!important";
				this.$bus.$emit("myspan", isWidth);
			},
			//*end

			//拉开
			toShow() {
				this.isHide = true;
				this.isShow = false;
				var isWidth = "220px!important";
				this.$bus.$emit("myspan", isWidth);
			}
		}
	}
</script>

<style scoped="scoped">
	.main{
		height:50px;
	}
	.iconFont {
		cursor: pointer;
		font-size: 22px;
		line-height: 50px;
	}

	.el-menu-demo .el-menu-item {
		height: 50px;
		line-height: 50px;
	}

	.refreshFont {
		text-align: center;
	}


	.out {
		position: relative;
		left: 82%;
		line-height: 50px;
		background: none;
		cursor: pointer;
		text-align: right;
		display: flex;
	}

	.out i {
		line-height: 50px;
		margin-right: 10px;
		margin-left:34px;
		font-weight: bold;
		font-size: 20px;
	}

	.out::after {
		content: '';
		display: block;
		width: 100%;
		height: 2px;
		position: absolute;
		top: 0;
		background: #03152a;
		transition: all 0.3s;
		transform: scale3d(0, 1, 1);
		transform-origin: 50% 0;
	}

	.out:hover::after {
		transform: scale3d(1, 1, 1);
	}

	.out:hover {
		color: #03152a;
	}

	/* 伸缩 */
	.shensuo::after {
		content: '';
		display: block;
		width: 100%;
		height: 2px;
		position: absolute;
		top: 0;
		background: #03152a;
		transition: all 0.3s;
		transform: scale3d(0, 1, 1);
		transform-origin: 50% 0;
	}

	.shensuo:hover::after {
		transform: scale3d(1, 1, 1);
	}

	/* 刷新 */
	.refreshFont::after {
		content: '';
		display: block;
		width: 100%;
		height: 2px;
		position: absolute;
		top: 0;
		background: #03152a;
		transition: all 0.3s;
		transform: scale3d(0, 1, 1);
		transform-origin: 50% 0;
	}

	.refreshFont:hover::after {
		transform: scale3d(1, 1, 1);
	}
	.signOut{
		font-size:16px;
	}
</style>
